import { API_URL } from '../circulusConfig';
import { encodeGetParams, getHeaders } from '../common/util';
import { POST, PATCH, PUT } from '../common/consts';

// 검색을 위한 메시지 데이터 목록 가져오기
const getUserMessagesAPI = async (data) => {
  const res = await fetch(`${API_URL}message?${encodeGetParams(data)}`);
  const result = res.json();
  return result;
};

const sendMessageAPI = async ({
  userId,
  type,
  mode,
  robots,
  fileName,
  blob,
  value,
}) => {
  // voice:  userId, type, mode, robots, fileName, blob
  // text: userId, type, mode, robots, value
  const payload = new FormData();
  payload.append('userId', userId);
  payload.append('robots', JSON.stringify(robots));
  payload.append('type', type);
  payload.append('mode', mode);
  payload.append('value', value);
  if (fileName && blob) {
    payload.append('file', blob, fileName);
  }
  const res = await fetch(`${API_URL}message`, {
    method: POST,
    body: payload,
  });
  const result = res.json();
  return result;
};

const updateMessageAPI = async (data) => {
  const res = await fetch(`${API_URL}message`, getHeaders(PATCH, { ...data }));
  const result = res.json();
  return result;
};
const deleteMessageAPI = async (data) => {
  const res = await fetch(`${API_URL}message`, getHeaders(PUT, { ...data }));
  const result = res.json();
  return result;
};

const getUserRobotsAPI = async ({ userId }) => {
  const res = await fetch(`${API_URL}message/robots/${userId}`);
  const result = res.json();
  return result;
};
export {
  getUserMessagesAPI,
  sendMessageAPI,
  updateMessageAPI,
  deleteMessageAPI,
  getUserRobotsAPI,
};
